import { UNLIMITED_PAGINATION_PARAMS } from 'constants/pagination';
import { Resources } from 'constants/resources';

import { GatewayRulesFormValues } from 'pages/GatewayRules/components/GatewayRulesForm/hooks/useGatewayRulesForm';
import { useGetList } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { Gateway } from 'types/embedded/gateway';
import { getId } from 'utils';
import { cleanEmpty } from 'utils/cleanEmpty';

export function useMappingGateways(mappingIndex: number) {
  const { watch } = useFormContext<GatewayRulesFormValues>();

  const merchantWatched = watch('merchant');
  const methodWatched = watch(`mappings.${mappingIndex}.method`);
  const directionWatched = watch(`mappings.${mappingIndex}.direction`);

  const { data: gateways = [], isLoading: isLoadingGateways } = useGetList<Gateway>(
    Resources.Gateways,
    {
      pagination: UNLIMITED_PAGINATION_PARAMS,
      filter: cleanEmpty({
        groups: ['reference'],
        'gatewayMethods.method': methodWatched || undefined,
        'merchantAccounts.merchants': merchantWatched || undefined,
        direction: getId(directionWatched?.toString()),
        status: ['active', 'test', 'pilot'],
      }),
    },
    {
      enabled: Boolean(merchantWatched && methodWatched && directionWatched),
    },
  );

  return { gateways, isLoadingGateways };
}
